import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { memo } from "react";
import { SpinnerOverlay } from "./SpinnerOverlay.js";
const SpinnerContainer = memo(({ enabled, children, size }) => /* @__PURE__ */ jsxs(Fragment, { children: [
  enabled && /* @__PURE__ */ jsx(SpinnerOverlay, { size }),
  children
] }));
SpinnerContainer.displayName = "SpinnerContainer";
export {
  SpinnerContainer
};
//# sourceMappingURL=SpinnerContainer.js.map
